/**
 * 首页
 */
// 轮播图
export const homeSwiperLists = [
    {
        img: require('../assets/img/banner2.png'),
        img2: require('../assets/img/1.png')
    }
]
// 产品与服务
export const homeProductLists = [
    {title:'电子商务平台',imgUrl: require('../assets/img/new-img/home-scene-01.jpg')},
]
// 服务领域
export const homeRangeList = [
    {
        title: '智慧城市',
        icon: 'icon-diannao',
        content: '城市大数据中心是智慧城市建设“一盘棋”的关键内核，利用云计算、大数据、人工智能等技术，通过数据和服务的融合，承载智慧应用场景中的相关应用，提供应用所需的各种服务和资源，用于支撑城市高质量发展全场景智慧的快速构建',
        id: 'customer'
    },
    {
        title: '数字乡村',
        icon: 'icon-shejiao-tuandui',
        content: '1.提升农业农村数据汇集服务能力<br/>' +
            '2.推进智能化数字化生产经营管理应用示范<br/>' +
            '3.完善农产品质量安全追溯体系<br/>' +
            '4.深化农产品营销数字化应用<br/>' +
            '5.提升乡村治理与服务水平<br/>' +
            '6.推动城乡信息化数字化融合发展',
        id: 'village'
    },
    {
        title: '大数据',
        icon: 'icon-jinrong',
        content: "1.元数据检索,理解与品谷、数据集成、数据开发、任务上线/调度、数据分析、数据应用<br/>" +
            "2.数据目录（Data Catalog）、数据工厂（DATAOps）<br/>" +
            "3.数据仓库、数据湖、云平台、存储",
        id: 'big-data'
    },
    {
        title: '数据安全',
        icon: 'icon-yiliao',
        content: '1.数据要素发展，治理先行<br/>' +
            '2.关基保护，安全重在弹性<br/>' +
            '3.科学数据安全分类分级<br/>' +
            '4.面向数字化保障的数据安全',
        id: 'security'
    },
    {
        title: '电子商务',
        icon: 'icon-zhengfu',
        content: '',
        id: 'company'
    },
    {
        title: '企业应用',
        icon: 'icon-icon_yingyongguanli',
        content: '提供企业通用架构，分布式、微服务、云架构、模块化、原子化、服务化、持续集成设计思想。',
        id: 'company'
    },
    {
        title: '移动App',
        icon: 'icon-jinrong',
        content: '原生APP（IOS/Android）、混合APP。客户需要的，就是骏驰天下践行提供的。',
        id: 'company'
    },
    {
        title: '云服务',
        icon: 'icon-yunjisuan-',
        content: '1.IaaS： Infrastructure-as-a-Service（基础设施即服务）<br/>' +
            '2.PaaS：Platform-as-a-Service（平台即服务）<br/>' +
            '3.SaaS：Software-as-a-Service（软件即服务）',
        id: 'service'
    },
]
// 合作伙伴
export const homeImgList = [
    require('../assets/img/logo/gjdw.png'),
    require('../assets/img/logo/hw.png'),
    require('../assets/img/logo/xdf.png'),
    require('../assets/img/logo/xhsd.png'),
    require('../assets/img/logo/zgyc.png'),
    require('../assets/img/logo/cbjt.png'),
    require('../assets/img/logo/abb.svg'),
    require('../assets/img/logo/jfjt.svg'),
]

/**
 * 产品与服务
 */
export const productSwiperLists = [
    {
        img: require("@/assets/img/test3.jpg"),
    },
]
// 智慧城市
export const cityList = [
    {
        title: '城市大数据中心',
        imgList: [],
        content:'城市大数据中心是智慧城市建设“一盘棋”的关键内核，利用云计算、大数据、人工智能等技术，通过数据和服务的融合，承载智慧应用场景中的相关应用，提供应用所需的各种服务和资源，用于支撑城市高质量发展全场景智慧的快速构建',
    },
    {
        title: '城市运营中心',
        imgList: [
            require('@/assets/img/zhsh/cs1.png'),
        ],
        content: '城市运营中心用于连接城市大数据中心和智慧业务场景，是城市综合治理窗口及指挥驾驶舱，承担城市大数据中心的数据调度和业务功能调度的功能，支撑城市大数据中心之上智慧业务的运转的数据和业务协同，实现“一图全感知、一键全联动、一机全流转”的智慧调度。'
    },
    {
        title: '经济发展运营中心',
        imgList: [
            require('@/assets/img/zhsh/jj1.png'),
            require('@/assets/img/zhsh/jj2.png'),
        ],
        content: '基于汇聚的城市经济运行各领域信息，从产业、行业、企业、区域、时间等多维度，对城市产业经济运行相关指标进行实时动态监测和预警，为城市经济可持续发展提供分析决策支撑。'
    },
    {
        title: '市域社会治理运营中心',
        imgList: [],
        childList: [
            {
                title: '风险分析',
                text: '基于海量数据资源，利用大数据分析技术，深度挖掘预警各类风险隐患，包括人的隐患、车的隐患、事的隐患、场所的隐患、企业的隐患以及其它隐患。'
            },
            {
                title: '舆情分析',
                text: '通过大数据让城市管理者及时了解互联网上的热门舆情信息，为下一步研判决策提供可靠的思路。'
            },
            {
                title: '市场监管',
                text: '借助人工智能与大数据技术手段，打造信息全面、重心明确、手段智能、风险预警的一站式市场监管平台，实现“事前、事中、事后”全流程智慧监管。'
            },
            {
                title: '应急管理',
                text: '围绕防灾与救灾并重、常态与非常态结合的业务需求，构建“统一指挥、专常兼备、反应灵敏、上下联动、平战结合”的智能化应急管理体系，实现应急管理全面感知、动态监测、智能预警、扁平指挥、快速处置、精准监管。'
            }
        ],
        content: ''
    },
    {
        title: '智慧交通运营中心',
        imgList: [
            require('@/assets/img/zhsh/zh1.png'),
        ],
        content: '全面汇聚感知人、车、路信息，接入交通管理、公路管理、车辆运营企业等相关数据，面向公路运行管理、交通枢纽管理、交通出行、交通治理、交通运输等交通运输核心业务信息化应用的协同化、平台化解决方案，全面推动城市交通决策科学化、交通治理精准化、运输服务品质化、信息服务均等化'
    },
    {
        title: '智慧健康运营中心',
        imgList: [
            require('@/assets/img/zhsh/jk1.png'),
        ],
        content: '汇聚多平台、跨机构的各类医疗健康数据，建设“互联网 +医疗健康”便民服务平台，全面赋能诊疗全流程，实现包括预约挂号、就诊费用自动结算、全市就医一码通用在内的便民服务。'
    },
]
// 大数据要求
export const requirements = [
    {
        imgUrl: require('@/assets/img/zhsh/data1.png'),
        content: '在复杂数据架构下，IT 和业务部门需要通过统一的工作界面来发现数据、定义数据和理解数据，消除数据的二义性，提升数据协作能力；'
    },
    {
        imgUrl: require('@/assets/img/zhsh/data2.jpg'),
        content: '数字化转型、智能化升级带来的需求，一方面企业内部场景都有降本增效的需求，另一方面企业都在向原生数字化企业发展，要实现业务数据化必须要规范建设大数据平台；'
    },
    {
        imgUrl: require('@/assets/img/zhsh/data3.png'),
        content: '随着数据管理新角色的出现，企业数据管理需要满足不同用户对数据的消费需求，解决业务用户对IT强依赖的问题，让数据使用能更加自助化'
    }
]
// 大数据解决方案
export const catalogList = [
    {
        title: 'Use case',
        options: ['元数据检索','理解与品谷','数据集成','数据开发','任务上线/调度','数据分析','数据应用',],
        imgUrl: require("@/assets/img/zhsh/case.png")
    },
    {
        title: 'Catalog + DataOps',
        options: ['数据目录（Data Catalog）','数据工厂（DATAOps）',],
        imgUrl: require("@/assets/img/zhsh/catalog.png")
    },
    {
        title: 'IAAS & PASS',
        options: ['数据仓库','数据湖','云平台','存储'],
        imgUrl: require("@/assets/img/zhsh/pass.png")
    }
]
// 大数据企业价值
export const valueList = [
    {
        logo: require("@/assets/img/tel.png"),
        imgUrl: require("@/assets/img/zhsh/low.jpeg"),
        icon: 'icon-gongju',
        title: "降低企业数据管理成本",
        content: "传统数据架构需要多个工具完成数据流水线，各类工具之间相互割裂，使用和维护成本较高。数造产品提供一站式的数据生命周期解决方案，大大降低企业数据管理和利用的成本"
    },
    {
        logo: require("@/assets/img/computer.png"),
        imgUrl: require("@/assets/img/zhsh/1000.png"),
        icon: 'icon-i-catalog',
        title: "快速实现企业数据的发现、开发和利用",
        content: "数造产品通过Catalog帮助用户快速发现和理解数据，通过DataOps解决复杂的数据流水线开发，解放数据开发生产力，实现快速数据研发和交付"
    },
    {
        logo: require("@/assets/img/qq.png"),
        imgUrl: require("@/assets/img/zhsh/data.jpeg"),
        icon: 'icon-Union-31',
        title: "提高企业数据合规和可信",
        content: "数造产品通过管控设计态和运行态，解决数据“两层皮”的问题，把数据合规、数据标准前置化和过程化，提升数据质量，保障企业数据的合规和可信"
    },
    {
        logo: require("@/assets/img/skill.png"),
        imgUrl: require("@/assets/img/zhsh/data.jpg"),
        icon: 'icon-jiaoseguanli',
        title: "满足业务自助数据使用需求",
        content: "随着大数据和AI的技术的发展，出现了一系列全新的市场需求，这些需求正在改变数据用户处理数据发现的方式，从而导致自助数据分析的增加。数造产品面向不同的数据角色，提供自助的数据发现、探索、分析能力，满足不同角色更加流畅的数据使用需求"
    }
]

export const customerList = [
    {title: '企业架构定制化',imgUrl: require('@/assets/img/new-img/pro-icon-1.jpg'),content:'提供企业通用架构，分布式、微服务、云架构、模块化、原子化、服务化、持续集成设计思想。',color:'#F99154'},
    {title: '功能定制开发',imgUrl: require('@/assets/img/new-img/pro-icon-2.jpg'),color: '#50BFE9',content: '基于Java技术，为客户提供各种个性化功能定制开发，从需求调研项目交付，骏驰天下全力以赴做好每个细节。'},
    {title: 'APP定制开发',imgUrl: require('@/assets/img/new-img/pro-icon-3.jpg'),color: '#FFB32E',content: '原生APP（IOS/Android）、混合APP。客户需要的，就是骏驰天下践行提供的。'},
    {title: '微信小程序定制开发',imgUrl: require('@/assets/img/new-img/pro-icon-4.jpg'),color: '#49CFAD',content: '微信小程序是移动互联网大应用，骏驰天下全面开启小程序定制开发服务，为移动互联网助力。'},
]

export const productLists = [
    {title: '电商平台',imgUrl:require('@/assets/img/new-img/service-01.jpg')},
    {title: '社交娱乐',imgUrl:require('@/assets/img/new-img/service-03.jpg')},
    {title: '分布式架构',imgUrl:require('@/assets/img/new-img/service-04.jpg')},
]

// 数字乡村
export const villageTargets = [
    {
        imgUrl: require('../assets/img/new-img/resolvent1.png'),
        title: '提升农业农村数据汇集服务能力',
        cot: [
            '1.完善乡村信息基础设施与网络安全架构',
            '2.构建乡村要素资源开放共享数据分中心',
            '3.云平台集成与“一张图”应用服务'
        ]
    },
    {
        imgUrl: require('../assets/img/new-img/resolvent2.png'),
        title: '推进智能化数字化生产经营管理应用示范',
        cot: [
            '1.创新智能化农业生产经营管理模式',
            '2.高水平美丽生态牧场建设与应用示范',
            '3.数字农业示范园区（基地）建设与应用示范'
        ]
    },
    {
        imgUrl: require('../assets/img/new-img/resolvent3.png'),
        title: '完善农产品质量安全追溯体系',
        cot: [
            '1.深入完善质量安全追溯体系建设与应用示范',
            '2.安全追溯体系与电商平台深入绑定',
            ''
        ]
    },
    {
        imgUrl: require('../assets/img/new-img/resolvent4.png'),
        title: '深化农产品营销数字化应用',
        cot: [
            '1.推进农村电商示范建设',
            '2.打造农产品区域公用品牌',
            ''
        ]
    },
    {
        imgUrl: require('../assets/img/new-img/resolvent5.png'),
        title: '提升乡村治理与服务水平',
        cot: [
            '1.提升乡村治理水平',
            '2.提高农村服务水平',
            '3.乡村数字信用服务创新'
        ]
    },
    {
        imgUrl: require('../assets/img/new-img/resolvent6.png'),
        title: '推动城乡信息化数字化融合发展',
        cot: [
            '1.积极开发乡村应用场景',
            '2.优化完善乡村数字驾驶舱',
            ''
        ]
    }
]

export const displayList = [
    {
        title: '展示平台',
        child: [
            '领导数字驾驶舱','农业智慧大屏','应用展示门户'
        ]
    },
    {
        title: '应用平台',
        child: [
            '数字化农业生产','智慧农业园','智慧食安追溯','智慧农村电商','智慧乡村治理','智慧乡村服务','农村数字普惠金融','经销宣传'
        ]
    },
    {
        title: '数据平台',
        child: [
            '数据中台','基础数据','城市大脑数据','农业监测数据','区块链','其他数据'
        ]
    },
    {
        title: '基础平台',
        child: [
            '农业基本设施','基础网络','云平台','物联网检测设备'
        ]
    }
]



// WEBPACK FOOTER //
// ./src/constant/constant.js